
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CommunicationLogEntryModel } from './Communication.Api.Models.CommunicationLogEntry';
import { Model, ModelProperty } from 'models/Model';


export class CommunicationLogEditModel extends Model<CommunicationLogEditModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'communicationLogEdit.property.id', isHidden: true },
		{ name: 'entryId', type: 'guid', languageString: 'communicationLogEdit.property.entryId' },
		{ name: 'comment', type: 'string', languageString: 'communicationLogEdit.property.comment' },
		{ name: 'userId', type: 'guid', languageString: 'communicationLogEdit.property.userId' },
		{ name: 'timestamp', type: 'Date', languageString: 'communicationLogEdit.property.timestamp' },
		{ name: 'entry', type: 'CommunicationLogEntryModel', languageString: 'communicationLogEdit.property.entry', isHidden: true, isObject: true, new: () => { return new CommunicationLogEntryModel }, properties: () => { return CommunicationLogEntryModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public entryId?: string;
	public comment: string;
	public userId?: string;
	public timestamp?: Date;
	public entry?: CommunicationLogEntryModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.entryId = undefined;
		this.comment = '';
		this.userId = undefined;
		this.timestamp = undefined;
		this.entry = undefined;
		
	}
	getProperties(){
		return CommunicationLogEditModel.classProperties;
	}
}

